import AdminClient from '../client/AdminClient';

class InvestmentService {
    static async update(investmentId, session, investment) {
        return AdminClient.put(`/v1/admin/tracked_investments/${investmentId}`, session, {tracked_investment: investment});
    }

    static async delete(investmentId, session) {
        return AdminClient.delete(`/v1/admin/tracked_investments/${investmentId}`, session);
    }
}
export default InvestmentService;